import React from "react";
import cart from "../images/cart/van_den_Hul_AJ.jpg";

export default function CartridgeRepair() {
  return (
    <div>
      {/* <div className="heading-section">
        <div className="section-heading">Corby's Audio Turntable Mat</div>
      </div> */}
      <div className="cartridge-repair-info">
        <div className="left-side">
          <img src={cart} alt="" />
        </div>
        <div className="right-side">
          <p>
            We now offer repair service to most MC cartridges. The repairs are
            performed by Mr. A.J. van den Hul. Typical turnaround time for
            repair is 2 weeks at factory plus the transit times. Pricing
            guidelines are below:
          </p>
          <div>
            <ul className="cartridge-repair-ul">
              <li>
                <span className="section-subheading">
                  2.0 Cartridge repairs
                </span>
                <span className="block mt-4">
                  The repair prices mentioned in the section below are an
                  indication, every repair is different, as is every cartridge.
                  A price quotation on demand is possible, but we will charge a
                  fee if the cartridge will not be repaired due to time and
                  resources spent.
                </span>
              </li>
              <li>
                <span className="section-subheading mt-4">
                  2.1 Repair quotation
                </span>
                <span className="block mt-4">
                  A request for a price quotation for any phono cartridge
                  repair, in case a cartridge is not repaired{" "}
                  <span className="price">$125.00</span>
                </span>
              </li>
              <li>
                <span className="section-subheading mt-4">
                  2.2 Cantilever and tip repairs
                </span>
                <span className="block mt-4">
                  If available and possible, the replacement of any aluminum
                  cantilever. <span className="price">$500.00</span> <br /> If
                  available and possible, the replacement of the tip of any
                  aluminum cantilever. $500.00
                  <br /> If available and possible, the replacement of the tip
                  of any boron or beryllium cantilever.{" "}
                  <span className="price">$600.00</span>
                  <br /> If available and possible, the replacement of the tip
                  of any sapphire or diamond cantilever.{" "}
                  <span className="price">$680.00</span>
                  <br /> If available and possible, the (re)placement of the tip
                  and boron cantilever. <span className="price">$850.00</span>
                </span>
              </li>
              <li>
                <span className="section-subheading mt-4">
                  2.3 Coil repairs
                </span>
                <span className="block mt-4">
                  If possible, repair of the coil of any phono cartridge.
                  <span className="price">$600.00</span> <br />
                  The replacement of the coil of any phono cartridge.{" "}
                  <span className="price">$950.00</span>
                </span>
              </li>
              <li>
                <span className="section-subheading mt-4">
                  2.4 Other repairs
                </span>
                <span className="block mt-4">
                  If possible, the replacement of the body of a VDH phono
                  cartridge, starting at <span className="price">$780.00</span>
                  <br /> Modifications of the magnet system in VDH phono
                  cartridges to change output level and resolution capabilities.
                  <span className="price">$350.00</span>
                  <br />
                  Replacement of the damper of all VDH phono cartridges, or any
                  non-VDH phono cartridge if available.{" "}
                  <span className="price">$180.00</span>
                </span>
              </li>
              <li>
                <span className="section-subheading mt-4">
                  2.4 Surcharge per cartridge
                </span>
                <span className="block mt-4">
                  Surcharge per standard job for all VDH cartridges{" "}
                  <span className="price">$20.00</span>
                  <br />
                  Surcharge per standard job for all non-VDH cartridges{" "}
                  <span className="price">$45.00</span>
                  <br />
                  Shipping to and from factory plus applicable taxes are extra.
                </span>
              </li>
            </ul>
          </div>

          <div className="flex flex-right">
            <div className="contact-button">
              <a href="mailto:info@corbysaudio.ca?subject=cartridge repair">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
